<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="profile-qts-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span> 
                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="dataFiltro" class="form-label">Data</label>
                                <input
                                    id="dataFiltro"
                                    v-model="dataFiltro"
                                    @keyup="apertouEnter"
                                    @blur="refreshTable"
                                    type="date"
                                    class="form-control form-control-solid"
                                    placeholder="Data"
                                />
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false" @tableatualizada="tableatualizada($event)">
                            <th style="max-width:100px">Id</th>
                            <th>Nome</th>
                            <th>Inicio</th>
                            <th>Fim</th>
                            <th>Atualizado em</th>
                            <th>Status</th>
                            <th style="min-width:190px" class="text-center">Acoes</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import $ from "jquery";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import QtsPdfService from "@/service/v10/sigap/QtsPdfService";

    @Options({
        name: "QtsPdf",
        components: { CardRh, KDataTable },
    })
    export default class QtsPdf extends Vue {
        @Prop() readonly matricula!: any;

        public turmaId: any = null;
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = new QtsPdfService();
        public dataFiltro = '';

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }
 
        created() {
            this.turmaId = this.matricula.turmaId;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.config.ajax = {
                url: this.service.getApiUrl() + '/Matricula/' + this.matricula.id,
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        turmaId: this.turmaId,
                        data: this.dataFiltro,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: 'id', name: 'id' },
                { data: 'nome', name: 'nome' },
                { data: 'inicio', name: 'inicio' },
                { data: 'fim', name: 'fim' },
                { data: 'updatedAt', name: 'updatedAt' },
                { data: 'status.nome', name: 'status.nome' },
            ];

            this.config.columnDefs = [
                {
                    targets: 2,
                    render: (row) => {
                        return SiteUtils.formatData(row);
                    }
                },
                {
                    targets: 3,
                    render: (row) => {
                        return SiteUtils.formatData(row);
                    }
                },
                {
                    targets: 4,
                    render: (row) => {
                        return SiteUtils.formatDataHora(row);
                    }
                },
            ];

            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs.push({
                targets: 6,
                render: (row, type, val) => {
                    let texto = '';
                    let buttom = '';
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-link ' + buttom + ' title="Link"><i class="fa fa-link"></i></button>';
                    return texto;
                },
            });
        }

        public tableatualizada() {
            $('[btn-link]').click((btn) => {
                const id = $(btn.currentTarget).data('id');
                this.getModelLink(id);
            });
        }

        protected getModelLink(id) {
            this.processando = true;
            setTimeout(() => {
                this.service.getModelLink(id)
                    .then(response => {
                        this.processando = false;
                        window.open(response, '_blank');
                    })
                    .catch(() => {
                        this.processando = false;
                    });
            }, 1);
        }
    }
</script>

<style scoped>
    .profile-qts-page {
        display: grid;
        gap: 24px;
    }

    .filter-panel,
    .table-panel {
        border: 1px solid #e5edf6;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
        padding: 15px;
    }

    .filter-panel {
        position: relative;
        padding-top: 24px;
    }

    .panel-border-label {
        position: absolute;
        top: -9px;
        left: 18px;
        padding: 0 10px;
        background: #ffffff;
        color: #102542;
        font-size: 0.95rem;
        font-weight: 800;
        line-height: 1.4;
    }

    .table-panel {
        padding: 2px 10px !important;
    }

    .panel-heading {
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 10px;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e9eef5;
    }

    .panel-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .btn-sm {
        margin-left: 10px;
    }

    .panel-actions .btn-sm {
        margin-left: 0;
    }

    @media screen and (max-width: 991px) {
        .filter-panel,
        .table-panel {
            padding: 18px;
            border-radius: 18px;
        }

        .filter-panel {
            padding-top: 26px;
        }

        .panel-heading {
            flex-direction: column;
            align-items: stretch;
        }
    }
</style>
